<table [class]="!this.equationRawText ? 'hidden' : 'inline'">
  <tr>
    <td><div #equationCell></div></td>
  </tr>
</table>

<div *ngIf="!equationRawText">{{ placeholder }}</div>
